import { useCallback, useMemo, useState } from 'react'
import { useNavigate } from 'react-router'

export const useUTMHandler = () => {
  const [utmSaved, setUTMSaved] = useState(false)
  const validUtmParams = useMemo(() => ['utm_content', 'utm_medium', 'utm_source', 'utm_campaign', 'utm_term'], [])
  const navigate = useNavigate()
  const saveUTMParams = () => {
    const parameters = new URLSearchParams(window.location.search)
    let hasUTMParam = false
    parameters.forEach((value, key) => {
      if (key.startsWith('utm_') && validUtmParams.includes(key)) {
        localStorage.setItem(key, value)
        hasUTMParam = true
      }
    })
    if (hasUTMParam) {
      setUTMSaved(true)
    }
  }

  const readUTMParams = useCallback(() => {
    const utmParams: { [key: string]: string } = {}
    for (const param of validUtmParams) {
      const utmParam = localStorage.getItem(param)
      if (utmParam) {
        utmParams[param] = utmParam
      }
    }
    return utmParams
  }, [validUtmParams])

  const deleteUTMParams = useCallback(() => {
    for (const param of validUtmParams) {
      localStorage.removeItem(param)
    }
  }, [validUtmParams])

  const appendUTMParams = useCallback(
    (url: string) => {
      const params = readUTMParams()
      const utmAppend = new URLSearchParams(params).toString()
      if (utmAppend) {
        return url + (url.indexOf('?') === -1 ? '?' : '&') + utmAppend
      }
      return url
    },
    [readUTMParams],
  )

  const navigateWithUTM = (url: string) => {
    navigate(appendUTMParams(url))
  }

  return {
    utmSaved,
    saveUTMParams,
    readUTMParams,
    deleteUTMParams,
    appendUTMParams,
    navigateWithUTM,
  }
}
